import 'font-awesome/css/font-awesome.min.css';
import Wifi from './../../assets/images/amenities/wifi.png';
import Printing from './../../assets/images/amenities/priting.png';
import Office from './../../assets/images/amenities/office.png';
import Coffee from './../../assets/images/amenities/coffee.png';
import Car from './../../assets/images/amenities/car.png';
import Camera from './../../assets/images/amenities/camera.png';
import Furniture from './../../assets/images/amenities/furniture.png';
import Telephone from './../../assets/images/amenities/telephone-booth.png';
import Conditioner from './../../assets/images/amenities/air-conditioner.png';
import Power from './../../assets/images/amenities/power-source.png';
import Library from './../../assets/images/amenities/library.png';
import Biometric from './../../assets/images/amenities/biometric.png';
import ImageOne from './../../assets/images/amenities/amenities-1.jpg';
import ImageTwo from './../../assets/images/amenities/amenities-2.jpg';
import DottedMap from './../../assets/images/amenities/dotted-map.png';
const Amenities = () => {
    return (
        <section className="amenities" id="amenities">
            <div className="container">
                <div className="row amenities-cover">
                    <div className="col-lg-12 mt-2">
                        <div className="section-title">
                            <h2>Amenities</h2>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 " >
                        <div className="row">
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                    <img src={Wifi} />
                                    <h6>Hight Speed Internet</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                    <img src={Printing} />
                                    <h6>Printing & Scanning</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Office} />
                                    <h6>Office Supplies</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Coffee} />
                                    <h6>Pantry</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Car} />
                                    <h6>Parking</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Camera} />
                                    <h6>CCTV</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Furniture} />
                                    <h6>Ergonomic Furniture</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Telephone} />
                                    <h6>Telephone Booth</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Conditioner} />
                                    <h6>Air Conditioner</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Power} />
                                    <h6>Power backup</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Library} />
                                    <h6>Access to Library</h6>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3">
                                <div className="amenities-item">
                                <img src={Biometric} />
                                    <h6>Biometric</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};
export default Amenities;